import React, { useState, Fragment } from "react"
import { useSelector } from "react-redux"

import { groupFoodsByOption } from "utils"
import { Button, Modal, } from "components"
import BuyXFreeXModalDoneButton from "./BuyXFreeXModalDoneButton"
import BuyXFreeXModalHeader from "./BuyXFreeXModalHeader"
import BuyXFreeXModalCard from "./BuyXFreeXModalCard"
import classes from "./index.module.scss"

const BuyXFreeXModal = props => {
  const {
    combo,
    onExited = () => { },
    openModal,
    setOpenModal,
    initialValues,
    orderComboIndex
  } = props

  const branchId =
    useSelector(state => state.userAccountInfo.branchId)

  const editMode = !!initialValues

  const initialSelectedComboItemsState =
    editMode ? initialValues : []

  const [selectedComboItems, setSelectedComboItems] =
    useState(initialSelectedComboItemsState)

  const handleExited = () => {
    onExited()

    if (editMode) return

    setSelectedComboItems([])
  }

  const groupedFoodsByOption =
    groupFoodsByOption(
      combo.foods,
      branchId
    )

  return (
    <Modal
      size="lg"
      
      onExited={handleExited}
      onHide={() => setOpenModal(false)}
      show={openModal}
    >
      <div className={classes["container"]}>
        <BuyXFreeXModalHeader
          combo={combo}
          selectedComboItems={selectedComboItems}
        />
        <div className={classes["main"]}>
          {combo.comboSets.map(comboSet => (
            <Fragment key={comboSet._id}>
              <div className={classes["title"]}>
                {comboSet.name}
              </div>
              <div className={classes["group"]}>
                {comboSet.items.map(comboSetItem => (
                  <div
                    key={comboSetItem._id}
                    className={classes["card"]}
                  >
                    <BuyXFreeXModalCard
                      editMode={editMode}
                      comboSetId={comboSet._id}
                      isFixed={comboSet.isFixed}
                      maxQty={comboSet.maxQty}
                      comboSetItem={comboSetItem}
                      selectedComboItems={selectedComboItems}
                      setSelectedComboItems={setSelectedComboItems}
                      groupedFoodsByOption={groupedFoodsByOption}
                    />
                  </div>
                ))}
              </div>
            </Fragment>
          ))}
        </div>
        <div className={classes["footer"]}>
          <Button
            color="info"
            onClick={() => setOpenModal(false)}
            className={classes["button"]}
          >
            لغو
          </Button>
          <BuyXFreeXModalDoneButton
            combo={combo}
            editMode={editMode}
            orderComboIndex={orderComboIndex}
            setOpenModal={setOpenModal}
            selectedComboItems={selectedComboItems}
          />
        </div>
      </div>
    </Modal>
  )
}

export default BuyXFreeXModal